import { helper as buildHelper } from '@ember/component/helper';

/**
 * Truncate text and replace with an optional string
 *
 * - params[0]    text to truncate
 * - params[1]    char count at which to truncate
 * - params[2]    Optional. The string to add after truncation.  e.g. '...'
 *
 * @param params
 * @return {Boolean}
 */
export function truncateText(params/*, hash*/) {
  let text = params[0],
    truncateCharCount = params[1],
    truncateWithText = params[2] ? params[2] : '';

  if (text.length <= truncateCharCount) {
    return text;
  }

  return text.substring(0, truncateCharCount) + truncateWithText;
}

export default buildHelper(truncateText);
